import moment from 'moment'
import { uuid } from 'vue-uuid'
import {
	STYLE_SETTINGS_GET,
	APP_CORE_SETTINGS_GET,
	CI_CD_SETTINGS_GET,
	WEB_SETTINGS_GET,
	BACK_USER_SETTINGS_GET,
	EVENT_SETTINGS_GET,
	CORE_SETTINGS_GET,
} from '../store/settings/types'
import TokenService from '@/services/token.service'

export const maybePluralize = (count, noun, suffix = 's') => {
	return `${count} ${noun}${count !== 1 ? suffix : ''}`
}
export const calcDateAgo = (date) => {
	const now = moment()
	const target = moment(date * 1000)

	const diffSeconds = now.diff(target, 'seconds')
	const diffMinutes = now.diff(target, 'minutes')
	const diffHours = now.diff(target, 'hours')
	const diffDays = now.diff(target, 'days')
	const diffMonths = now.diff(target, 'months')
	const diffYears = now.diff(target, 'years')

	if (diffSeconds < 60) {
		return 'now'
	}

	if (diffMinutes < 60) {
		return `${diffMinutes}m ago`
	}

	if (diffHours < 24) {
		return `${diffHours}h ago`
	}

	if (diffDays < 30) {
		return `${diffDays}d ago`
	}

	if (diffMonths < 12) {
		return `${diffMonths}mo ago`
	}

	return `${diffYears}y ago`
}

export const normalizePost = (item) => {
	let {
		id = null,
		created_at = null,
		title = '',
		content = 'N/A',
		tags = [],
		thumbnail = null,
		isCurrentUserLike = null,
		comments = null,
		likes_count = null,
		author = {},
		locationName = null,
		latitude = 0,
		longitude = 0,
		comments_count = 0,
	} = item
	const date = moment(created_at).format('MMMM DD')
	const authorName = author?.name || author?.email || 'Unknown author'

	const authorAvatar = author?.avatar || ''
	const likes = likes_count || 0
	locationName = locationName || 'Unknown location'
	const isLiked = isCurrentUserLike || false
	const lat = parseFloat(latitude)
	const long = parseFloat(longitude)

	return {
		id,
		title,
		content,
		created_at,
		date,
		tags,
		thumbnail,
		comments,
		likes_count,
		isCurrentUserLike,
		authorName,
		authorAvatar,
		locationName,
		likes,
		isLiked,
		lat,
		long,
		comments_count,
	}
}

export const normalizeFeaturedPost = (item) => {
	let { id = null, title = '', content = 'N/A', background_image_url = '' } = item

	content = content.substring(0, 150)

	return {
		id,
		title,
		content,
		image: background_image_url,
	}
}

export const normalizePreviewPost = (item) => {
	let {
		id = null,
		created_at = null,
		title = '',
		content = 'N/A',
		tags = [],
		thumbnail = null,
		isCurrentUserLike = null,
		comments = null,
		likes_count = null,
		author = {},
		locationName = null,
	} = item

	const date = moment(created_at).format('MMMM DD')
	const authorName = author?.name || author?.email || 'N/A'
	const authorAvatar = author?.avatar || ''
	locationName = locationName || 'Unknown location'
	content = content.substring(0, 200)

	return {
		id,
		title,
		content,
		created_at,
		date,
		tags,
		thumbnail,
		comments,
		likes_count,
		isCurrentUserLike,
		authorName,
		authorAvatar,
		locationName,
	}
}

export const normalizeComment = (item) => {
	let {
		thread_reply_id: id = null,
		thread_id: threadId,
		reply_text: review = 'N/A',
		upvote: upvote,
		upvote_count: upvoteCount,
		user = {},
		replies = [],
		created: updated_at = null,
		created: created_at = new Date(),
	} = item

	const authorName = user?.visible_username || 'N/A'
	const authorAvatar = user?.user_logo || undefined
	const userId = user.user_id || undefined
	const date = calcDateAgo(created_at)
	const content = review

	return {
		id,
		date,
		threadId,
		userId,
		authorName,
		authorAvatar,
		updated_at,
		replies,
		content,
		user,

		upvoteCount,
		upvote,
	}
}

export const normalizeAuthor = (item) => {
	let { id = null, name = 'N/A', email = 'N/A', avatar = '', isCurUserSubscribe = false } = item

	name = name ? name : email ? email : 'N/A'

	return {
		id,
		name,
		avatar,
		isCurUserSubscribe,
	}
}

export const getParsedMenu = (jsonMenu) => {
	return JSON.parse(jsonMenu)
}

export const getBaseMenuItems = (parseMenu, allowsTypes) => {
	return parseMenu.reduce(
		(prev, { name, url, role, icon, block, chapters = [], exclude_chapters, params = {} }) => {
			let route = url ? extractRouteFromUri(url) : null
			const menuType = url ? extractMenuTypeFromUri(url) : null

			const isCurrentRouteAllow = menuType ? allowsTypes.includes(menuType) : false

			let queryParams = {}
			let chips = []

			const { allow_posting: allowPosting } = params
			if (menuType === 'threads') {
				queryParams = {
					thread_menu_id: params.thread_menu_id,
					enable_all_comments: params.enable_all_comments ? 1 : 0,
				}

				if (params.thread_filter_chips_title && params.thread_filter_chips) {
					chips = getNormalizedChips(
						{
							...params,
							thread_filter_chips_title: params.thread_filter_chips_title ?? '',
							thread_filter_chips: params.thread_filter_chips ?? '',
						},
						'thread_filter_chips_title',
						'thread_filter_chips'
					)
				}

				if (allowPosting) {
					queryParams = {
						...queryParams,
						category_id: allowPosting[0],
					}
				}
			}

			if (menuType === 'resources') {
				queryParams = {
					advance: params.enable_advanced ? 1 : 0,
				}
				chips = getNormalizedChips(
					{
						...params,
						resources_filter_chips_title: params.resources_filter_chips_title ?? '',
						resources_filter_chips: params.resources_filter_chips ?? '',
					},
					'resources_filter_chips_title',
					'resources_filter_chips'
				)
			}

			if (menuType === 'directory') {
				queryParams = {
					category_id: params.category_id,
				}

				chips = getNormalizedChips(
					{
						...params,
						directory_filter_chips_title: params.directory_filter_chips_title ?? '',
						directory_filter_chips: params.directory_filter_chips ?? '',
					},
					'directory_filter_chips_title',
					'directory_filter_chips'
				)
			}

			if (menuType === 'rss-feed') {
				queryParams = {
					feed_id: params.feed_id,
				}
			}

			if (isCurrentRouteAllow) {
				return [
					...prev,
					{
						title: name,
						chips,
						route: {
							name: route,
							query: queryParams,
						},
						icon,
						role,
						block,
						chapters,
						params,
						exclude_chapters,
					},
				]
			}

			return prev
		},
		[]
	)
}

export const getWebViewMenuItems = (parseMenu, allowsTypes) => {
	return parseMenu.reduce(
		(prev, { name, url, role, icon, block, chapters = [], params = {} }) => {
			const { url: uriWebView } = params
			const menuType = extractMenuTypeFromUri(url)
			const isCurrentRouteAllow = allowsTypes.includes(menuType)

			if (isCurrentRouteAllow) {
				return [
					...prev,
					{
						id: uuid.v4(),
						title: name,
						route: uriWebView,
						role,
						icon,
						block,
						chapters,
					},
				]
			}

			return prev
		},
		[]
	)
}

export const extractRouteFromUri = (uri) => {
	const parts = uri.split('://')
	if (parts.length === 2) {
		return parts[1].split('/').join('/')
	}
	return null
}

export const extractMenuTypeFromUri = (uri) => {
	const parts = uri.split('://')

	if (parts.length === 2) {
		return parts[1]
	}
	return null
}

export const getNormalizedChips = (params, filterTitle, filterName) => {
	const safeParams = params || {}
	const { [filterTitle]: threadFilterChipsTitle = '', [filterName]: threadFilterChips = '' } =
		safeParams

	const splitThreadFilterChips = threadFilterChips?.split(',')
	const splitThreadFilterChipsTitle = threadFilterChipsTitle?.split(',')

	return _.zipWith(splitThreadFilterChips, splitThreadFilterChipsTitle, (name, content) => ({
		name,
		content,
	})).filter((item) => item.name && item.content)
}

export const checkSetting = (settingName) => {
	const settings = JSON.parse(localStorage.getItem('settings'))
	if (settings && settings[settingName]) {
		return settings[settingName].expiryIn > new Date().getTime()
			? settings[settingName].value
			: null
	}
	return null
}

export const getCachedSettings = (store) => {
	const settingsArray = [
		{
			name: 'app_core',
			set: APP_CORE_SETTINGS_GET,
			get: 'getAppCoreSettings',
		},
		{
			name: 'ci_cd',
			set: CI_CD_SETTINGS_GET,
			get: 'getCiCdSettings',
		},
		{
			name: 'web',
			set: WEB_SETTINGS_GET,
			get: 'getWebBlockSettings',
		},
		{
			name: 'styles',
			set: STYLE_SETTINGS_GET,
			get: 'getStyleSettings',
		},
		{
			name: 'back_user',
			set: BACK_USER_SETTINGS_GET,
			get: 'getBackUserSettings',
		},
		{
			name: 'event',
			set: EVENT_SETTINGS_GET,
			get: 'getEventsSettings',
		},
		{
			name: 'dwh',
			set: null,
			get: 'getDwhUrl',
		},
		{
			name: 'core',
			set: CORE_SETTINGS_GET,
			get: 'getBaseCoreSettings',
		},
	]
	settingsArray.forEach((setting) => {
		const cache = checkSetting(setting.name)

		cache
			? setting.set && store.commit(`settings/${setting.set}`, cache)
			: store.dispatch(`settings/${setting.get}`)
		if (setting.name === 'dwh' && cache) {
			store.dispatch('settings/sendDwhAction', {
				credentials: cache,
				payload: {
					category: 'App Start',
					action: 'app_launch',
					module: 'App Launch',
					session_id: store.getters['app/sessionId'],
					version: process.env.VUE_APP_VERSION || undefined,
					platform: 'web app',
					login: TokenService.getEmailFromStorage() || null,
				},
			})
		}
	})
}

export const cacheSetting = (type, payload) => {
	localStorage.setItem(
		'settings',
		JSON.stringify({
			...JSON.parse(localStorage.getItem('settings')),
			[type]: {
				value: payload,
				expiryIn: new Date().getTime() + 1000 * 60 * 5,
			},
		})
	)
}

export const updateAgendaItem = (state, id, agenda) => {
	return state.agenda.map((item) => {
		if (item.events_agenda_id === id) {
			return agenda
		} else {
			return item
		}
	})
}
export const removeAgendaItem = (state, id) => {
	return state.agenda.filter((item) => item.events_agenda_id !== id)
}
export function getSafeDwhCreds() {
	try {
		const raw = localStorage.getItem('settings')
		if (!raw) return null
		const parsed = JSON.parse(raw)
		return parsed?.dwh?.value ?? null
	} catch {
		return null
	}
}
export const debounce = (fn, delay = 300) => {
	let timeout = null

	return function (...args) {
		clearTimeout(timeout)

		timeout = setTimeout(() => {
			fn.apply(this, args)
		}, delay)
	}
}
